import axios from "../plugins/parseAxios";
export class ProjectAPI {
  constructor(props) { }
  static updateProject(payload) {
    return axios.post("functions/updateProject", payload);
  }
  static getProjectOverAllAreaData(payload){
    return axios.post("functions/getProjectOverAllAreaData", payload);
  }
  static getProjectOverAllProductData(payload){
    return axios.post("functions/getProjectOverAllProductData", payload);
  }
  static getProjectOverAllProductCategoryData(payload){
    return axios.post("functions/getProjectOverAllProductCategoryData", payload);
  }
  static getProjectOverAllAccountingProductData(payload){
    return axios.post("functions/getProjectOverAllAccountingProductData", payload);
  }
  static getProjectOverAllContractData(payload){
    return axios.post("functions/getProjectOverAllContractData", payload);
  }
  static getProjectOverAllAreaBookingData(payload){
    return axios.post("functions/getProjectOverAllAreaBookingData", payload);
  }
  static getProjectOverAllInvoiceData(payload){
    return axios.post("functions/getProjectOverAllInvoiceData", payload);
  }
  static getProject(payload) {
    return axios.post("functions/getProject", payload);
  }
}
